export const urls = {
  GET_RADNE_NALOGE: 'DokRNServisni/vrati_dok_rn_servisni',
  GET_RADNE_NALOGE_FILTER: 'DokRNServisni/rn_servisni_pregled_sa_filterom',
  GET_STATUSI_COMBO: 'Combo/vrati_statuse_dok_rn_servisni',
  DELETE_RADNI_NALOG: 'DokRNServisni/brisanje_dok_rn_servisni',
};
